import { createAsyncThunk } from "@reduxjs/toolkit";
import { alertError } from "shared/api/alertError";
import { personalCabinetAPI } from "../api/index";

interface postApplicationMoneyCreateThunk {
  distanceId: number | undefined;
}

export const postApplicationMoneyCreateThunk = createAsyncThunk(
  "personalCabinet/postApplicationMoney",
  async (data: postApplicationMoneyCreateThunk, { rejectWithValue }) => {
    try {
      const newTab = window.open("about:blank", "_blank");
      const res = await personalCabinetAPI.postApplicationMoney(data);
      if (res.data) {
        if (newTab) {
          newTab.location.href = res.data;
        } else {
          window.location.href = res.data;
        }
      } else {
        window.location.reload();
      }
      return res.data;
    } catch (error: any) {
      if (error.response.data.title) {
        alertError(error.response.data.title);
      }
      return rejectWithValue(error.response.data.title);
    }
  }
);
